import React from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { CheckmarkCircle01Icon } from '@hugeicons/core-free-icons';
import ResponsiveModal from './ResponsiveModal';
import Button from './Button';

const ExportSuccessModal = ({ isOpen, onClose, type }) => {
  if (!isOpen) return null;

  return (
    <ResponsiveModal isOpen={isOpen} onClose={onClose} title="Export Successful">
      <div className="text-center py-8">
        <div className="mx-auto flex items-center justify-center h-16 w-16 rounded-full bg-green-50 dark:bg-green-900/20 mb-6">
          <HugeiconsIcon icon={CheckmarkCircle01Icon} size={32} className="text-soft-green dark:text-light-mint" />
        </div>
        <h3 className="text-xl font-bold text-charcoal dark:text-white mb-2">
          {type.toUpperCase()} Export Complete
        </h3>
        <p className="text-muted-gray">
          Your transaction history has been successfully exported.
        </p>
        <div className="mt-8">
          <Button onClick={onClose} className="w-full sm:w-auto px-6 py-2.5">
            Done
          </Button>
        </div>
      </div>
    </ResponsiveModal>
  );
};

export default ExportSuccessModal;
